<template>
  <b-navbar
    toggleable="lg"
    class="main-header line"
  >
    <b-navbar-brand>
      <Logo />
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" />

    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <b-navbar-nav class="navigation-items">
        <NavbarItems />
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <GlobalSearch />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Logo from '@/components/layout/headerItems/Logo';
import NavbarItems from '@/components/layout/headerItems/NavbarItems';
import GlobalSearch from '@/components/layout/headerItems/GlobalSearch';

export default {
  name: 'Header',
  components: {
    NavbarItems,
    Logo,
    GlobalSearch,
  },
  data() {
    return {
    };
  },
};
</script>
